<template>
    <div class="voucher-slide">
        <div class="splide" id="voucher-slide">
            <div class="splide__track">
                <ul class="splide__list">
                    <li class="splide__slide"
                        v-for="(voucher, k) in vouchers" :key="k">

                        <div class="voucher-item">
                            <div class="voucher">
                                <div class="voucher-img">
                                    <img :src="voucher.fullImageUrl"/>
                                </div>
                                <div class="voucher-content">
                                    <div>{{ lbl.home.condition }}</div>
                                    <div>
                                        <div class="btn-redeem-voucher"
                                             @click="clickRedeem(voucher)">
                                            <img src="../../../../assets/new/icon/ic-coupon.png"/>
                                            <div>{{ lbl.home.get_code }}</div>
                                        </div>
                                        <!-- <div class="btn-use-voucher"
                                             @click="gotoCart('')">
                                            <img src="../../../../assets/new/icon/ic-use-coupon.png"/>
                                            <div>ใช้เลย</div>
                                        </div> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>

        <!-- <div class="voucher-pagination-prev">
            <button class="bg-yellow-400 p-2 mr-4" @click="btnPrev()">Prev</button>
        </div> -->
        <div class="voucher-pagination-next">
            <img @click="btnNext()" src="../../../../assets/new/icon/ic-pagination-next.png"/>
        </div>
    </div>
</template>
<script>
import Splide from '@splidejs/splide'; //https://splidejs.com/
import Locale from '@/helper/locale/Locale';

export default {
    name: 'VoucherSlider',
    components: {

    },
    props: {
        voucher: Array
    },
    data: function () {
        return {
            localeCode: Locale.getLocaleCode(),
            lbl: Locale.getLbl(),

            vouchers: [],
            slider: null,
            currentSliderIndex: 0,
        };
    },mounted: function () {

    },
    created: function () {
        this.vouchers = this.voucher;
        this.setSlider()
    },
    methods: {
        clickRedeem: function (voucher) {
            this.$emit('redeemVoucher', voucher);
        },
        setSlider: function() {
            this.$nextTick(() => {
                this.slider = new Splide('#voucher-slide', {
                    type : 'slide',
                    autoWidth: true,
                    pagination : false,
                    arrows: false,
                    gap: 15,
                }).mount()

                this.slider.on('move', (newIndex) => {
                    this.currentSliderIndex = newIndex
                })
            })
        },
        btnNext: function() {
            let next = this.currentSliderIndex + 1
            this.slider.go(next)
        },
        btnPrev: function() {
            let prev = this.currentSliderIndex - 1
            this.slider.go(prev)
        },

    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";

.voucher-slide {
    position: relative;
    .voucher-item {
        width: 100%;
        max-width: 304px;
        .voucher-img {
            width: 100%;
            height: 100%;
            border-radius: 10px;
            img {
                border-top-left-radius: 10px;
                border-top-right-radius: 10px;
            }
        }
        .voucher-content {
            display: flex;
            justify-content: space-between;
            background-color: white;
            padding: 11px 13px;
            border-bottom-left-radius: 10px;
            border-bottom-right-radius: 10px;
            font-size: $px16;
            color: $a-black-333333;

            .btn-redeem-voucher {
                display: flex;
                gap: 4px;
                background-color: $a-orange-f8a51b;
                color: white;
                padding: 4px 8px;
                font-size: $px16;
                border-radius: 5px;

                img {
                    width: 22px;
                }
            }

            .btn-use-voucher {
                display: flex;
                gap: 4px;
                background-color: white;
                color: $a-orange-f8a51b;
                padding: 4px 8px;
                font-size: $px16;
                border-radius: 5px;
                border: solid 1px $a-orange-f8a51b;

                img {
                    width: 22px;
                }
            }
        }
    }

    .voucher-pagination-prev {
        position: absolute;
        top: 30px;
        left: -30px;
        width: 100%;
    }
    .voucher-pagination-next {
        position: absolute;
        top: 35%;
        right: -30px;
    }
}
</style>
